import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ValuePropositions } from './components/ValuePropositions';
import { WhoWeHelp } from './components/WhoWeHelp';
import { HowItWorks } from './components/HowItWorks';
import { ClientSuccess } from './components/ClientSuccess';
import { CallToAction } from './components/CallToAction';
import { OurPackages } from './components/OurPackages';
import { Footer } from './components/Footer';
import { Phone } from 'lucide-react';
import { SmoothScroll } from './components/utils/SmoothScroll';
import { Metadata } from './components/Metadata';
import { HelmetProvider } from 'react-helmet-async';
export function App() {
  return <HelmetProvider data-id="element-0">
      <SmoothScroll data-id="element-1">
        <Metadata data-id="element-2" />
        <div className="bg-black text-white w-full min-h-screen overflow-x-hidden" data-id="element-3">
          <Header data-id="element-4" />
          <main className="overflow-x-hidden" data-id="element-5">
            <HeroSection data-id="element-6" />
            <ValuePropositions data-id="element-7" />
            <WhoWeHelp data-id="element-8" />
            <HowItWorks data-id="element-9" />
            <OurPackages data-id="element-10" />
            <ClientSuccess data-id="element-11" />
            <CallToAction data-id="element-12" />
          </main>
          <Footer data-id="element-13" />
          {/* Sticky Phone Button */}
          <a href="https://calendly.com/callvanasolutions-info/30min" target="_blank" rel="noopener noreferrer" className="fixed bottom-8 right-8 z-50 w-16 h-16 bg-gradient-to-r from-blue-primary to-blue-light rounded-full flex items-center justify-center shadow-lg shadow-blue-primary/20 hover:scale-110 transition-all duration-300 group" aria-label="Schedule a call" data-id="element-14">
            <div className="absolute inset-0 bg-blue-light rounded-full animate-ping opacity-20" data-id="element-15"></div>
            <Phone size={28} className="text-white group-hover:animate-pulse" data-id="element-16" />
          </a>
        </div>
      </SmoothScroll>
    </HelmetProvider>;
}